import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./sensorActions";

// ==================== SENSOR READINGS ====================

function* fetchSensorReadings(action) {
    try {
        const { batchId } = action.payload;

        // Use JWT-authenticated endpoint for web users (not the API key endpoint)
        const url = `/mycore/record/sensor-readings/?batch_id=${batchId}&limit=500`;

        const result = yield call(AxiosCall, url);
        yield put(actions.fetchSensorReadingsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchSensorReadingsFailure(e.message));
    }
}

function* fetchSensorStats(action) {
    try {
        const { batchId } = action.payload;
        // Stats are now included in the monitoring summary endpoint
        // This saga is kept for future use if we need separate stats endpoint
        const result = yield call(AxiosCall, `/mycore/record/summary/?batch_id=${batchId}`);
        yield put(actions.fetchSensorStatsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchSensorStatsFailure(e.message));
    }
}

// ==================== ROOT SAGA ====================

export default function* sensorSaga() {
    yield all([
        takeLatest(actions.FETCH_SENSOR_READINGS.REQUEST, fetchSensorReadings),
        takeLatest(actions.FETCH_SENSOR_STATS.REQUEST, fetchSensorStats),
    ]);
}
